export default "__VITE_ASSET__BhXKHyhB__"